import React from 'react';
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import Grid from "@material-ui/core/Grid";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import Typography from "@material-ui/core/Typography";
import NumberFormat from "react-number-format";
import {price} from "../../../../utils/formatters/Numbers";
import {dateDDMMYY} from "../../../../utils/formatters/Date";
import {calculateAmount, calculateReward} from "../../../../utils/calculate/Amount";
import {RadioButton} from "primereact/radiobutton";
import {Calendar} from "primereact/calendar";
import {Divider} from "@material-ui/core";
import InstrumentDropDown from "../../../../components/dropDown/instrument";
import {InputText} from "primereact/inputtext";
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";
import {CALENDAR_ES} from "../../../../utils/constants/Constants";
import PropTypes from "prop-types";

const InsertOrderBorrower = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <Grid container spacing={1}>
                    <Grid item xs={8}>
                        <TitlePage title='Prestatario \ Solicitud de Valores \ Insertar Postura'/>
                    </Grid>
                    <Grid item xs={4}>
                        <Grid container spacing={2} justify="flex-end">
                            <Grid item>
                                <Button label="Alta Emisora" onClick={props.newInstrumentScreen}
                                        className="p-button-secondary"/>
                            </Grid>
                            <Grid item>
                                <Button label="Cerrar" onClick={props.handleReturnButton}
                                        className="p-button-secondary"/>
                            </Grid>
                            <Grid item>
                                <Button
                                    label="Guardar"
                                    onClick={props.insertOrderBorrower}
                                    tabIndex={5}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <div className="p-col-12">
                        <Divider/>
                    </div>
                    <Grid item xs={12}>
                        <div className="p-grid">
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Emisora" isBold={true}/>
                                <InstrumentDropDown
                                    name="catInstrument"
                                    filter="emisoraSerieCupon"
                                    save={props.saveDataOrderBorrower}
                                    value={props.orderBorrower.catInstrument}
                                    loading={props.loading}
                                    tabIndex={1}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Títulos" isBold={true}/>
                               <NumberFormat
                                    name="amount"
                                    value={props.orderBorrower.amount}
                                    thousandSeparator={true}
                                    onChange={props.saveDataOrderBorrower}
                                    allowNegative={false}
                                    maxLength={17}
                                    required={true}
                                    decimalScale={0}
                                    fixedDecimalScale={false}
                                    placeholder="Ex: 99,99"
                                    customInput={InputText}
                                    tabIndex={2}/>
                            </div>
                            <div className="p-col-12 p-md-12 p-lg-4">&nbsp;</div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Tasa" isBold={true}/>
                                <NumberFormat
                                    name="rate"
                                    customInput={InputText}
                                    value={props.orderBorrower.rate}
                                    thousandSeparator={true}
                                    allowNegative={false}
                                    onChange={props.onChangeRate}
                                    decimalScale={2}
                                    tabIndex={3}
                                    id={9}
                                    maxLength={16}
                                    placeholder="Ex: 99,99"/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Plazo" isBold={true}/>
                                <NumberFormat
                                    name="maturity"
                                    value={props.orderBorrower.maturity}
                                    thousandSeparator={true}
                                    onChange={props.saveDataOrderBorrower}
                                    tabIndex={4}
                                    maxLength={5}
                                    decimalScale={0}
                                    allowNegative={false}
                                    fixedDecimalScale={false}
                                    placeholder="Ex: 99,99"
                                    customInput={InputText}/>
                            </div>
                            <div className="p-col-12 p-md-12 p-lg-4">&nbsp;</div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Sobretasa" isBold={true}/>
                                <NumberFormat
                                    name="surcharge"
                                    decimalScale={2}
                                    id={9}
                                    customInput={InputText}
                                    allowNegative={false}
                                    value={props.orderBorrower.surcharge}
                                    thousandSeparator={true}
                                    onChange={props.onChangeRate}
                                    tabIndex={4}
                                    maxLength={16}
                                    placeholder="Ex: 99,99"/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Fecha Vencimiento" isBold={true}/>
                                <Typography variant="subtitle2" gutterBottom
                                    style={props.validDate ? {} : {color: "red"}}>
                                    {dateDDMMYY(props.maturityDate)}
                                </Typography>
                            </div>
                            <div className="p-col-12 p-md-12 p-lg-4">&nbsp;</div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Precio" isBold={true}/>
                                <SubtitleLabel header={
                                    price(props.orderBorrower.catInstrument !== null ?
                                        props.orderBorrower.price : 0)} />
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Total" isBold={true}/>
                                <SubtitleLabel header= {
                                    calculateAmount(props.orderBorrower.catInstrument !== null ?
                                        props.orderBorrower.price : 0,
                                        props.orderBorrower.amount)}/>
                            </div>
                            <div className="p-col-12 p-md-12 p-lg-4">&nbsp;</div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Vigencia" isBold={true}/>
                                <RadioButton
                                    inputId="today"
                                    name="today"
                                    value="today"
                                    checked={props.orderType === 'today'}
                                    onChange={props.saveRadioButtonOption}
                                    disabled={props.orderBorrower.disabledRadio}/>
                                <label htmlFor="today" className="p-radiobutton-label">Diaria</label>
                                &nbsp;
                                <RadioButton
                                    inputId="week"
                                    name="week"
                                    value="week"
                                    checked={props.orderType === 'week'}
                                    onChange={props.saveRadioButtonOption}
                                    disabled={props.orderBorrower.disabledRadio}/>
                                <label htmlFor="week" className="p-radiobutton-label">Semanal</label>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Premio" isBold={true}/>
                                <SubtitleLabel header={
                                    calculateReward(props.orderBorrower.amount,
                                        props.orderBorrower.catInstrument !== null ?
                                            props.orderBorrower.price : 0,
                                        props.orderBorrower.rate,
                                        props.orderBorrower.maturity)} />
                            </div>
                            <div className="p-col-12 p-md-12 p-lg-4">&nbsp;</div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Fecha Valor" isBold={true}/>
                                <Calendar
                                    name="valueDate"
                                    dateFormat={"dd/mm/yy"}
                                    value={props.orderBorrower.valueDate}
                                    disabledDays={[0, 6]}
                                    readonlyInput={true}
                                    onChange={props.saveDataOrderBorrower}
                                    minDate={props.today}
                                    maxDate={props.maxValueDate}
                                    monthNavigator={true}
                                    yearNavigator={true}
                                    yearRange={CALENDAR_ES['yearRange']}
                                    locale={CALENDAR_ES}
                                    showButtonBar={true}
                                />
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};
InsertOrderBorrower.propTypes = {
    onChangeRate: PropTypes.func.isRequired
}
export default (InsertOrderBorrower);